const initailState = {
  requestGetData: [],
  loadings: false,
};

export function inspectionRequestReducer(
  state = initailState,
  { type, payload }
) {
  switch (type) {
    case "GET_INSPECT_REQUEST":
      return { ...state, requestGetData: payload, loadings: false };
    case "GET_INSPECTION_LOGGING":
      return { ...state, loadings: true };
    case "GET_INSPECTION_LOGGED":
      return { ...state, loadings: false };
    default:
      return state;
  }
}

export function inspectionResponseReducer(
  state = {
    loadings: false,
  },
  { type, payload }
) {
  switch (type) {
    case "POST_INSPECT_RESPONSE":
      return { ...state, loadings: false };
    case "POST_RESPONSE_LOADDING":
      return { ...state, loadings: true };
    case "POST_RESPONSE_LOADDED":
      return { ...state, loadings: false };
    default:
      return state;
  }
}

export function inspectionForSellerReducer(
  state = { sellerInspection: [], loadings: false },
  { type, payload }
) {
  switch (type) {
    case "GET_INSPECT_REQUEST_SELLER":
      return { ...state, sellerInspection: payload, loadings: false };
    case "GET_INSPECTION_LOGGING_SELLER":
      return { ...state, loadings: true };
    case "GET_INSPECTION_LOGGED_SELLER":
      return { ...state, loadings: false };
    default:
      return state;
  }
}
